const NOT_QUOTED_MESSAGE =
  'Esta carteira ainda não foi cotizada com o cálculo mais recente. Cotize para reconciliar os dados.'

export const WALLET_WARNING_RULES = [
  {
    match: 'modo legacy',
    message: NOT_QUOTED_MESSAGE,
    action: 'cotizar',
    actionLabel: 'Cotizar',
  },
  {
    match: 'Histórico de cotiz',
    message: NOT_QUOTED_MESSAGE,
    action: 'cotizar',
    actionLabel: 'Cotizar',
  },
]
